import type { IconName } from '@/ui';

export interface NavItem {
  label: string;
  /** Legacy WebsiteTranslates key for `t()`. */
  translateKey?: string;
  to: string;
  icon?: IconName;
  /** Optional TanStack Router search params (e.g. betslip My bets tab). */
  search?: Record<string, string | undefined>;
  /**
   * When set, the mobile tab opens live chat instead of navigating.
   * Shown only when `Account.Chat` is true.
   */
  action?: 'open-chat';
}

/** Desktop TopNav, matching the Figma `Active` variants. */
export const PRIMARY_NAV: NavItem[] = [
  { label: 'Home', translateKey: 'Home', to: '/' },
  { label: 'Sports', translateKey: 'Sports', to: '/sports' },
  { label: 'Live', translateKey: 'LiveBetting', to: '/live' },
  { label: 'Casino', translateKey: 'Casino', to: '/casino' },
  { label: 'Promos', translateKey: 'Promotions', to: '/promotions' },
];

/** Mobile bottom bar, matching the Figma `Active` variants / Menu Icons. */
export const MOBILE_NAV: (Required<Pick<NavItem, 'label' | 'translateKey' | 'to' | 'icon'>> &
  Pick<NavItem, 'search' | 'action'>)[] = [
  { label: 'Home', translateKey: 'Home', to: '/', icon: 'home' },
  { label: 'Live', translateKey: 'LiveBetting', to: '/live', icon: 'live-icon' },
  {
    label: 'Bet Slip',
    translateKey: 'Betslip',
    to: '/betslip',
    search: {},
    icon: 'menu-betslip',
  },
  {
    label: 'Tickets',
    translateKey: 'MyBets',
    to: '/betslip',
    search: { tab: 'my-bets' },
    icon: 'ticket',
  },
  { label: 'Slots', translateKey: 'Slots', to: '/casino', icon: 'menu-casino' },
  {
    label: 'Chat',
    translateKey: 'Chat',
    to: '/page/support',
    icon: 'menu-chat',
    action: 'open-chat',
  },
];

export const FOOTER_LINKS: NavItem[] = [
  { label: 'About', translateKey: 'About', to: '/page/about' },
  { label: 'Responsible Gaming', translateKey: 'ResponsibleGambling', to: '/page/responsible-gaming' },
  { label: 'Terms', translateKey: 'Terms', to: '/page/terms' },
  { label: 'Privacy', translateKey: 'Privacy', to: '/page/privacy' },
  { label: 'Help', translateKey: 'Help', to: '/page/help' },
  { label: 'Partners', translateKey: 'Partner', to: '/partner' },
];

/**
 * Placeholder sports menu. The real counts come from the sports API once the
 * sportsbook feature lands.
 */
export const SPORTS_MENU = [
  { label: 'Football', slug: 'football', icon: 'football', count: 186 },
  { label: 'Basketball', slug: 'basketball', icon: 'basketball', count: 64 },
  { label: 'Tennis', slug: 'tennis', icon: 'tennis', count: 42 },
  { label: 'Ice Hockey', slug: 'ice-hockey', icon: 'icehockey', count: 28 },
  { label: 'Volleyball', slug: 'volleyball', icon: 'volleyball', count: 19 },
  { label: 'Table Tennis', slug: 'table-tennis', icon: 'tabletennis', count: 31 },
  { label: 'Esports', slug: 'esports', icon: 'esports', count: 55 },
] as const;
